/* Sorti de la page le 19 aout 2026 : ce code est le meme pour toutes les
   pages, donc il appartient a un fichier que le navigateur garde en cache,
   pas au HTML qui est retelecharge a chaque visite.

   La garde ci-dessous existe parce qu'un fichier charge deux fois s'execute
   deux fois, ce qui doublerait les ecouteurs. */
if (!window.__fvPackMeterJs) {
  window.__fvPackMeterJs = true;
(function () {
    /* ── Compter les polos, pas les articles ──
       On somme les quantites des lignes dont le type produit est « Polo ».
       Compter aveuglement toutes les lignes marcherait aujourd'hui, la
       boutique ne vend que des polos, et casserait le jour ou une
       casquette entrerait au catalogue. Le barème porte sur les polos ;
       le code doit dire la meme chose. */
    var TYPE = 'polo';

    /* Le formateur vit dans `fv-money` : il porte la devise de presentation du
       visiteur, celle-la meme que les prix rendus en Liquid sur la page. On le
       lit a chaque appel plutot qu'une fois pour toutes, pour ne pas figer un
       `undefined` si l'ordre de chargement change. Le repli en dollars n'est
       pas une preference, c'est le dernier recours. */
    function money(n) {
      if (window.FVMoney) return window.FVMoney(n);
      return '$' + (Math.round(n * 100) % 100 === 0 ? Math.round(n) : n.toFixed(2));
    }

    function unitFor(n, L) {
      if (n >= 5) return L.p5;
      if (n >= 3) return L.p3;
      if (n >= 2) return L.p2;
      return L.p1;
    }

    /* Le prochain palier : combien de polos manquent, et a quel prix on
       tombe. Renvoie null quand le client est deja au meilleur prix, il
       n'y a alors plus rien a lui demander, et insister serait grossier. */
    function nextStep(n, L) {
      if (n < 2) return { need: 2 - n, at: 2, unit: L.p2 };
      if (n < 3) return { need: 3 - n, at: 3, unit: L.p3 };
      if (n < 5) return { need: 5 - n, at: 5, unit: L.p5 };
      return null;
    }

    /* ── Ou la phrase a le droit de se couper ──
       Les segments etaient colles par des espaces insecables autour du point
       median : le navigateur n'avait alors AUCUN endroit ou couper entre deux
       segments, et il coupait donc a l'interieur, en plein milieu de
       « free shipping ». C'est l'inverse qu'il faut : le point median est le
       SEUL endroit ou la ligne a le droit de se couper (espaces normaux
       autour), et chaque segment est insecable (`seg`). */
    /* Le point separateur est colle a ce qui le SUIT par une espace insecable,
       et precede d'une espace ordinaire. C'est ce sens-la et pas l'autre:
       quand la phrase passe a deux lignes sur telephone, la coupure se fait
       AVANT le point, qui descend avec la clause qu'il introduit. Colle au mot
       precedent, il resterait pendu en bout de premiere ligne, ce qui est le
       defaut qu'on corrige. Constate le 24 aout sur la barre flottante. */
    var SEP = ' <span class="fv-meter-sep">&middot;</span>&nbsp;';
    function seg(html) { return '<span class="fv-meter-seg">' + html + '</span>'; }

    function countPolos(cart) {
      var items = (cart && cart.items) || [];
      var n = 0;
      for (var i = 0; i < items.length; i++) {
        var t = (items[i].product_type || '').toLowerCase();
        if (t === TYPE || t === '') n += items[i].quantity;
      }
      return n;
    }

    function render(el, n) {
      var L = {
        p1: parseFloat(el.dataset.p1), p2: parseFloat(el.dataset.p2),
        p3: parseFloat(el.dataset.p3), p5: parseFloat(el.dataset.p5)
      };
      var ship = parseInt(el.dataset.ship, 10) || 3;
      var announce = el.dataset.announce !== '0';
      var elState = el.querySelector('[data-fv-meter-state]');
      var elNext = el.querySelector('[data-fv-meter-next]');
      var elTrack = el.querySelector('[data-fv-meter-track]');
      var elFill = el.querySelector('[data-fv-meter-fill]');
      var elBag = el.querySelector('[data-fv-meter-bag]');
      var step = nextStep(n, L);

      /* Panier vide ou non : la barre flottante n'affiche pas la meme chose
         dans les deux cas (voir le CSS de .fv-meter--empty). Le CSS ne peut
         pas le deviner, seul ce script lit le panier. */
      el.classList.toggle('fv-meter--empty', n === 0);

      if (elBag) {
        elBag.hidden = n === 0;
        elBag.textContent = 'View bag (' + n + ')';
      }

      /* Panier vide : on ne parle pas de progression, il n'y a rien a
         faire progresser. L'accroche prend la place de la relance: c'est
         elle qui propose, et l'escalier se deroule en petit dessous. */
      if (n === 0) {
        /* La jauge apparait des le panier vide, a zero.

           Avant elle etait cachee tant que rien n'etait ajoute, au motif qu'il
           n'y a rien a faire progresser. C'etait l'inverse du besoin: c'est
           justement au client qui n'a encore rien mis qu'il faut montrer qu'il
           y a une echelle a gravir, et ce que le premier pas rapporte. Une
           jauge qui n'apparait qu'apres l'ajout ne recompense que ceux qui
           avaient deja decide.

           On annonce donc le premier palier utile, deux polos, avec l'economie
           en dollars: c'est le chiffre qui parle, pas le pourcentage. */
        elNext.innerHTML = 'Add 2 polos &#8594; <b>' + money(L.p2) + ' each</b>, save '
                         + money((L.p1 - L.p2) * 2);
        if (elTrack) { elTrack.hidden = false; elFill.style.width = '0%'; }
        elState.innerHTML = announce
          ? seg('3 polos ' + money(L.p3) + ' each') + SEP
            + seg('5 or more ' + money(L.p5) + ' each') + SEP
            + '<b>free shipping from ' + ship + ' polos</b>'
          : 'The more polos in your bag, the less each one costs.';
        return;
      }

      var unit = unitFor(n, L);
      var word = n === 1 ? 'polo' : 'polos';
      elState.innerHTML = announce
        ? seg(n + ' ' + word + ' in your bag') + SEP + '<b>' + money(unit) + ' each</b>'
        : n + ' ' + word + ' in your bag';

      /* La barre mesure toute l'echelle, de 0 au meilleur prix, pas la
         distance au palier suivant. Mesuree par palier, elle reculait :
         2 polos sur 3 remplissaient 67 %, puis le troisieme polo ramenait
         a 60 % puisque la cible devenait 5. Le client venait de faire ce
         qu'on lui demandait et voyait sa progression diminuer. Une jauge
         qui recule sur une bonne action ne se lit plus comme une jauge. */
      if (elTrack) {
        elTrack.hidden = false;
        elFill.style.width = Math.min(100, Math.round((n / 5) * 100)) + '%';
      }

      /* ── Deux objectifs, pas un ──
         Le barème et la livraison offerte sont deux leviers distincts et ils
         ne tombent pas au meme moment. L'ancienne version ne parlait que du
         prix : la pastille « Free shipping » n'apparaissait qu'une fois le
         seuil franchi, donc elle ne servait qu'a feliciter, jamais a pousser.
         Le client a qui il manquait un seul polo pour la livraison offerte ne
         l'apprenait pas, on lui cachait la raison la plus simple d'en
         ajouter un.

         Desormais on annonce toujours l'objectif le plus proche en premier,
         et l'autre en second s'il reste a atteindre. Ce qui est deja acquis
         passe en pastille : c'est un acquis, pas une consigne. */
      var shipNeed = Math.max(0, ship - n);
      var shipDone = shipNeed === 0;
      var shipPill = shipDone ? '<span class="fv-meter-ship">&#10038; Free shipping unlocked</span>' : '';

      function polos(k) { return k === 1 ? '1 more polo' : k + ' more polos'; }

      /* ── AU-DELA DU MEILLEUR PRIX, LA BARRE NE DOIT PAS SE TAIRE ──
         Ajoute le 18 aout 2026.

         Elle disait « Best price reached » et s'arretait la. Le client
         comprenait qu'il n'avait plus rien a gagner, donc il s'arretait
         aussi, a cinq polos. C'est une erreur d'economie : le calcul du
         18 aout montre que le polo qui suit le cinquieme rapporte trois
         fois plus que le troisieme, parce qu'il n'y a plus de remise
         retroactive a absorber. Ce sont les polos les plus rentables du
         catalogue et rien ne les demandait.

         Ce qu'on annonce ne coute rien. A 45 $ le polo, on est a 60 % du
         prix public de 75 $, donc 40 % des polos sont offerts, et ce
         rapport ne bouge plus jamais. L'accroche exacte tombe donc a
         chaque multiple de cinq, et elle grossit toute seule :
             5 polos  = 225 $ = 3 x 75 $  ->  BUY 3, GET 2 FREE
            10 polos  = 450 $ = 6 x 75 $  ->  BUY 6, GET 4 FREE
            15 polos  = 675 $ = 9 x 75 $  ->  BUY 9, GET 6 FREE
         Le prix unitaire ne baisse pas d'un centime entre les trois. Seule
         la formulation grandit, et elle reste vraie au dollar pres.

         `freeEq` calcule combien de polos sont offerts au palier vise, en
         partant du prix plein `p1`. Si le barème change un jour dans les
         reglages, la phrase suit sans qu'on la reecrive. */
      function freeEq(k, unit, full) {
        if (!full || full <= unit) return 0;
        return Math.round(k - (k * unit) / full);
      }
      function nextFive(k) { return (Math.floor(k / 5) + 1) * 5; }

      if (!step) {
        var goal = nextFive(n);
        var gFree = freeEq(goal, L.p5, L.p1);
        var gPaid = goal - gFree;
        var gNeed = goal - n;
        /* On ne pousse au palier suivant que s'il reste vraiment quelque
           chose a dire : il faut que des polos y soient offerts. */
        var canPush = announce && gFree > 0 && gNeed > 0 && goal <= 20;

        if (canPush) {
          elNext.innerHTML = 'Add <b>' + polos(gNeed) + '</b> &rarr; <b>buy ' + gPaid
            + ', get ' + gFree + ' free</b>' + (shipDone ? shipPill : '');
          if (elTrack) {
            elTrack.hidden = false;
            elFill.style.width = Math.min(100, Math.round((n / goal) * 100)) + '%';
          }
          return;
        }
        if (shipDone) {
          elNext.innerHTML = announce
            ? 'Best price reached. Every extra polo stays at <b>' + money(L.p5) + '</b>.' + shipPill
            : 'You have the best price.' + shipPill;
        } else {
          elNext.innerHTML = 'Add <b>' + polos(shipNeed) + '</b> &rarr; <b>free shipping</b>'
            + (announce ? '. Best price already reached at ' + money(L.p5) + ' each.' : '. Best price already reached.');
        }
        return;
      }

      /* Les deux objectifs tombent sur le meme polo : une seule phrase, et
         c'est la plus forte que l'encart puisse dire. */
      if (!shipDone && shipNeed === step.need) {
        elNext.innerHTML = announce
          ? 'Add <b>' + polos(step.need) + '</b> &rarr; <b>' + money(step.unit) + ' each + free shipping</b>'
          : 'Add ' + polos(step.need) + ' &rarr; <b>lower price + free shipping</b>';
        return;
      }

      /* La livraison arrive avant la baisse de prix : on mene avec elle. Un
         seuil de port franco se comprend sans calcul, la ou une remise
         demande de comparer, a distance egale, il convertit mieux. */
      if (!shipDone && shipNeed < step.need) {
        elNext.innerHTML = 'Add <b>' + polos(shipNeed) + '</b> &rarr; <b>free shipping</b>'
          + (announce ? SEP + seg(polos(step.need) + ' for ' + money(step.unit) + ' each') : '');
        return;
      }

      /* Sinon la baisse de prix est la plus proche. On la mene, et on garde
         la livraison en second si elle reste a decrocher. */
      var tail = !shipDone ? SEP + seg(polos(shipNeed) + ' for free shipping') : shipPill;
      elNext.innerHTML = announce
        ? 'Add <b>' + polos(step.need) + '</b> &rarr; <b>' + money(step.unit) + ' each</b>' + tail
        : 'Add ' + polos(step.need) + ' and the price drops.' + tail;
    }

    function renderAll(n) {
      var list = document.querySelectorAll('[data-fv-meter]');
      for (var i = 0; i < list.length; i++) render(list[i], n);

      /* La sortie vers le panier a ete retiree de la barre le 24 aout: elle
         est remplacee par un chevron qui deplie les vignettes du panier sur
         place, sans quitter la page. Le comptage de ce bouton vit desormais
         dans snippets/fv-pack-bar.liquid, avec le tiroir qu'il ouvre. */

      /* La pastille de palier a ete retiree de la barre le 24 aout: dans un
         objet unique, un classement ne distingue rien, et « Best seller » sur
         une boutique sans historique de ventes n'est pas verifiable.
         L'escalier de l'encart dit ou en est le client, avec les prix. */

      /* Un seul endroit sait combien de polos sont au panier ; le reste du
         theme peut s'y accrocher sans refaire un appel reseau. */
      document.documentElement.setAttribute('data-fv-polos', n);
      document.dispatchEvent(new CustomEvent('fv:polos', { detail: { polos: n } }));
    }

    function pull() {
      var el = document.querySelector('[data-fv-meter]');
      if (!el) return;
      fetch((el.dataset.cartUrl || '/cart') + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { renderAll(countPolos(cart)); })
        .catch(function () { renderAll(0); });
    }

    /* Le panier peut changer sans que la page bouge : ajout depuis le
       tiroir, retrait d'une ligne, ajout depuis le catalogue. On ecoute
       donc l'evenement que ces surfaces emettent deja, et on se contente
       de relire, jamais de deviner le nouveau total de son cote. */
    document.addEventListener('cart:update', function (e) {
      if (e.detail && e.detail.cart) { renderAll(countPolos(e.detail.cart)); return; }
      pull();
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', pull);
    } else {
      pull();
    }
  })();
}
